import { render, staticRenderFns } from "./SocialTemplate.vue?vue&type=template&id=192b09cc&scoped=true&"
import script from "./SocialTemplate.vue?vue&type=script&lang=js&"
export * from "./SocialTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192b09cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('192b09cc')) {
      api.createRecord('192b09cc', component.options)
    } else {
      api.reload('192b09cc', component.options)
    }
    module.hot.accept("./SocialTemplate.vue?vue&type=template&id=192b09cc&scoped=true&", function () {
      api.rerender('192b09cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/SocialTemplate.vue"
export default component.exports